import { API_HANDLERS } from '@/api';
import { ICohortsFilterResponseParams, IGetCohortsRequest } from '@/types';

export const getCohorts = async (
  params?: IGetCohortsRequest,
): Promise<ICohortsFilterResponseParams[]> => {
  try {
    const { data } = await API_HANDLERS.FILTERS.GET_COHORTS(params);

    return data;
  } catch (error) {
    return Promise.reject(new Error(`Get Cohorts Filters Error: ${error}`));
  }
};
